import React, { useState, useEffect } from "react";
import {
  Modal,
  Form,
  Select,
  Card,
  Button,
  Popconfirm,
  Switch,
  InputNumber,
  DatePicker,
  message,
  Row,
  Col,
} from "antd";
import {
  apiGetTicketPolicy,
  apiUpdateTicketPolicy,
  apiDeleteTicketPolicy,
} from "../../api/api";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

const EditAfterSaleModal = ({
  isEditAfterSaleOpen,
  setIsEditAfterSaleOpen,
  policyData,
  setPolicyData,
  fetchData,
  eventTimezone = "Asia/Taipei",
}) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    form.setFieldsValue(policyData);
    form.setFieldValue("switchDateTimeRange", [
      policyData?.switchStartDateTime
        ? dayjs(policyData.switchStartDateTime * 1000)
        : null,
      policyData?.switchEndDateTime
        ? dayjs(policyData.switchEndDateTime * 1000)
        : null,
    ]);
    form.setFieldValue("refundDateTimeRange", [
      policyData?.refundStartDateTime
        ? dayjs(policyData.refundStartDateTime * 1000)
        : null,
      policyData?.refundEndDateTime
        ? dayjs(policyData.refundEndDateTime * 1000)
        : null,
    ]);
  }, [policyData]);

  const fetchTicketPolicy = async (id) => {
    setIsLoading(true);
    try {
      const res = await apiGetTicketPolicy({ id });
      setPolicyData(res.data?.content);
    } catch (error) {
      message.error("獲取票券政策失敗");
    } finally {
      setIsLoading(false);
    }
  };

  const handleUpdate = async (values) => {
    console.log("handleUpdate values", values);
    const { switchDateTimeRange, refundDateTimeRange, ...restValues } = values;
    setIsLoading(true);
    const switchStartDateTime = switchDateTimeRange
      ? dayjs.tz(values.switchDateTimeRange[0].$d, eventTimezone).utc().unix()
      : null;
    const switchEndDateTime = switchDateTimeRange
      ? dayjs.tz(values.switchDateTimeRange[1].$d, eventTimezone).utc().unix()
      : null;
    const refundStartDateTime = refundDateTimeRange
      ? dayjs.tz(values.refundDateTimeRange[0].$d, eventTimezone).utc().unix()
      : null;
    const refundEndDateTime = refundDateTimeRange
      ? dayjs.tz(values.refundDateTimeRange[1].$d, eventTimezone).utc().unix()
      : null;

    try {
      await apiUpdateTicketPolicy({
        id: policyData.id,
        data: {
          ...restValues,
          switchStartDateTime,
          switchEndDateTime,
          refundStartDateTime,
          refundEndDateTime,
        },
      });
      message.success("更新成功");
      fetchTicketPolicy(policyData.id);
    } catch (error) {
      message.error("更新失敗");
    } finally {
      setIsEditAfterSaleOpen(false);
      setIsLoading(false);
      fetchData();
    }
  };

  return (
    <Modal
      open={isEditAfterSaleOpen}
      onCancel={() => setIsEditAfterSaleOpen(false)}
      footer={null}
      width={600}
      title="編輯售後退換票"
    >
      <Form
        form={form}
        onFinish={handleUpdate}
        layout="horizontal"
        initialValues={policyData}
      >
        <Row>
          <Col span={12}>
            <Form.Item
              label="是否開放換票"
              name="enableSwitchPolicy"
              valuePropName="checked"
            >
              <Switch />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="是否開放退款"
              name="enableRefundPolicy"
              valuePropName="checked"
            >
              <Switch />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item label="換票是否可跨活動" name="switchRangeType">
          <Select
            options={[
              { value: 1, label: "僅限本場活動" },
              { value: 2, label: "開放跨活動" },
            ]}
          ></Select>
        </Form.Item>
        <Form.Item label="換票時間範圍" name="switchDateTimeRange">
          <DatePicker.RangePicker
            showTime
            className="w-full"
            format="YYYY-MM-DD HH:mm"
            value={
              policyData?.switchStartDateTime
                ? dayjs(policyData.switchStartDateTime * 1000)
                : null
            }
          />
        </Form.Item>

        <Form.Item label="退票時間範圍" name="refundDateTimeRange">
          <DatePicker.RangePicker
            className="w-full"
            showTime
            format="YYYY-MM-DD HH:mm"
          />
        </Form.Item>
        <Form.Item className="text-right">
          <Button type="primary" htmlType="submit" loading={isLoading}>
            更新設定
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditAfterSaleModal;
